export default {
  buttonPrevious: {
    id: 'cart_replace_button_previous_accessibility',
    defaultMessage: 'Previous',
  },
  buttonNext: {
    id: 'cart_replace_button_next_accessibility',
    defaultMessage: 'Next',
  },
}
